module.exports = __webpack_public_path__ + "static/gallery_peak_4_thumb-2fd8a5930f7c59d5f4e78b3698324650.jpg";